module.exports = __webpack_public_path__ + "static/img/wild4.68d8393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild4.png
// module id = rtbl
// module chunks = 0